import React from "react";
import { connect } from "react-redux";

import cx from "classnames";
import numeral from "numeral";
import dateFormat from "dateformat";

import { Row, Col } from "react-bootstrap";
import EntityReport from "../components/reports";

import DefaultAssetIcon from "../../../images/defaultAsset.jpg"

import styles from '../reports.module.scss';

import _ from "lodash";

import {
  prepareRequest,
  formatName,
  formatTimespent,
} from "../../../services/report.service";
import {
  fetchDiscoveryContentMatrix,
  fetchDiscoveryContentMatrxAssets,
} from "../../../redux/actions/reports"
import { Tooltip as ReactTooltip } from "react-tooltip";
import { localizedStrings } from '../../../../localization/index';
import CustomTooltip from "src/components/tooltip"
import Tooltip from "src/components/tooltip";

class DiscoveryMatrixReport extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      request: null,
      viewMore: false,
      report: {
        id: "discovery_content_matrix",
        title: "",
        tooltipText: ""
      },
    };

    this.fetchAssetsForDiscoveryType =
      this.fetchAssetsForDiscoveryType.bind(this);

    this.localizedKeywords = localizedStrings.keywords;
    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
    this.localizedHeaders = this.localizedTabsCommons.headers;
    this.localizedContent = this.localizedReport.tabs.discovery.content_discovery;
    this.localizedDiscovery = this.localizedReport.tabs.discovery;
  }

  componentDidMount() {
    this.loadReport(this.props.request);
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.request, nextProps.request)) {
      this.loadReport(nextProps.request);
    }
  }

  loadReport(request) {
    if (!request) {
      return;
    }

    const processedRequest = prepareRequest(
      request,
      this.props.supportedEntities
    );
    if (!_.isEqual(this.state.request, processedRequest)) {
      this.setState(
        {
          request: processedRequest,
        },
        () => {
          this.props.fetchData(processedRequest);
        }
      );
    }
  }

  handleMatrixClicked(type) {
    const matrix = _.get(this.props.value, type);

    if (!matrix) {
      return;
    }

    var title = "";
    var tooltipText = "";
    const localizedContentDiscovery = this.localizedReport.tabs.discovery.tooltip_texts.content_discovery
    switch (type) {
      case "low":
        title = this.localizedContent.low;
        tooltipText = localizedContentDiscovery.low_discovery
        break;
      case "belowAverage":
        title = this.localizedContent.below_average;
        tooltipText = localizedContentDiscovery.below_average_discovery
        break;
      case "average":
        title = this.localizedContent.average;
        tooltipText = localizedContentDiscovery.average_discovery
        break;
      case "high":
        title = this.localizedContent.high_discovery;
        tooltipText = localizedContentDiscovery.high_discovery
        break;
      default:
    }

    this.setState({
      report: {
        id: "discovery_content_matrix",
        title: title,
        type: type,
        data: matrix,
        tooltipText: tooltipText
      },
      viewMore: true,
    });
  }

  fetchAssetsForDiscoveryType(request, page, limit) {
    const from = this.state.report.data.lower;
    const to = this.state.report.data.upper;

    const updated = {
      ...request,
      fromViews: from,
      toViews: to,
    };
    this.setState({
      request: updated,
    });

    this.props.fetchAssets(updated, page, limit);
  }

  render() {
    const low = _.get(this.props.value, "low.count");
    const belowAverage = _.get(this.props.value, "belowAverage.count");
    const average = _.get(this.props.value, "average.count");
    const high = _.get(this.props.value, "high.count");
    const total = Math.max(low + belowAverage + average + high, 1);

    return (
      <div className={cx(styles.discoveryMatrixReport, this.props.className)}>

        <h5 className={styles.title}>
          <span>{this.localizedContent.title}({total})</span>
          <span className={styles.contentDiscoverTooltip}>
            <CustomTooltip content={this.props.tooltipText} placement="top">
              <i className="paperflite-info"></i>
            </CustomTooltip>
          </span></h5>
        <div className={styles.gridContainer}>

          <div
            className={cx(styles.matrix, styles.lowDiscovery)}
            onClick={this.handleMatrixClicked.bind(this, "low")}
          >
            <h3 className={styles.percentageLabel}>{numeral(low / total).format("0.0%")}</h3>
            <div className={styles.metadata}>{low} {this.localizedKeywords.assets}</div>
            <div className={styles.description}>{this.localizedContent.low}</div>
          </div>
          <div
            className={cx(styles.matrix, styles.belowAverage)}
            onClick={this.handleMatrixClicked.bind(this, "belowAverage")}
          >
            <h3>{numeral(belowAverage / total).format("0.0%")}</h3>
            <div className={styles.metadata}>{belowAverage} {this.localizedKeywords.assets}</div>
            <div className={styles.description}>{this.localizedContent.below_average}</div>
          </div>
          <div
            className={cx(styles.matrix, styles.averageDiscovery)}
            onClick={this.handleMatrixClicked.bind(this, "average")}
          >
            <h3>{numeral(average / total).format("0.0%")}</h3>
            <div className={styles.metadata}>{average} {this.localizedKeywords.assets}</div>
            <div className={styles.description}>{this.localizedContent.average}</div>
          </div>
          <div
            className={cx(styles.matrix, styles.highDiscovery)}
            onClick={this.handleMatrixClicked.bind(this, "high")}
          >
            <h3>{numeral(high / total).format("0.0%")}</h3>
            <div className={styles.metadata}>{high} {this.localizedKeywords.assets}</div>
            <div className={styles.description}>{this.localizedContent.high_discovery}</div>
          </div>

        </div>

        <EntityReport.Popup
          show={this.state.viewMore}
          id={this.state.report.id}
          title={this.state.report.title}
          icon={"paperflite-popular-viewers"}
          className={this.props.className}
          request={this.state.request}
          data={this.props.assets}
          fetchData={this.fetchAssetsForDiscoveryType}
          tooltipText={this.state.report.tooltipText}
          renderer={this.state.report.type == "low" ? AssetItem : AssetGridItem}
          columns={[
            {
              title: "",
              width: 6,
            },
            {
              title: this.localizedTabsCommons.unique_users,
              width: 2,
            },
            {
              title: this.localizedTabsCommons.views,
              width: 2,
            },
            {
              title: this.localizedTabsCommons.avg_time,
              width: 2,
            },
          ]}
          onClose={() => {
            this.setState({ viewMore: false });
          }}
          downloadProperties={{
            // download localization
            headers: [
              [this.localizedHeaders.asset_name],
              [this.localizedHeaders.created_date],
              [this.localizedHeaders.author],
              [this.localizedHeaders.views],
              [this.localizedHeaders.avg_time],
              [this.localizedHeaders.shares],
            ],
            fileName: "DiscoveryContentMatrix.csv",
          }}
        />
      </div>
    );
  }
}

class AssetGridItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.localizedCommons = localizedStrings.commons;
    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    return (
      <Row className={styles.row}>
        <Col className={styles.column} md={6}>
          <a
            href={`/assets/${this.props.item.asset.id}/?source=reports`}
            target="_blank"
            className={cx(styles.item, styles.asset, this.props.className)}
          >
            <img
              className={styles.icon}
              src={
                _.get(this.props.item, "asset.icon.thumbnail") ||
                DefaultAssetIcon
              }
            />
            <div className={styles.discoveryTitle}>

              <Tooltip content={_.get(this.props.item, 'asset.name')} placement="bottom">
                <h5 className={styles.title}>
                  {_.get(this.props.item, "asset.name")}
                </h5>
              </Tooltip>

              <ul className={styles.metrics}>
                <li>
                  {this.localizedCommons.added}:{" "}
                  {dateFormat(this.props.item.asset.createdDate, "dd mmm yyyy")}
                </li>
                <li>{this.localizedTabsCommons.author}: {formatName(this.props.item.asset.author)}</li>
              </ul>
            </div>
          </a>
        </Col>
        <Col className={styles.column} md={2}>
          {_.get(this.props.item, "analytics.users", 0)}
        </Col>
        <Col className={styles.column} md={2}>
          {_.get(this.props.item, "analytics.views", 0)}
        </Col>
        <Col className={styles.column} md={2}>
          {formatTimespent(_.get(this.props.item, "analytics.avgTimeSpent", 0))}
        </Col>
      </Row>
    );
  }
}

class AssetItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.localizedCommons = localizedStrings.commons;
    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    return (
      <Row className={styles.row}>
        <Col className={styles.column} md={6}>
          <a
            href={`/assets/${this.props.item.asset.id}?source=reports`}
            target="_blank"
            className={cx(styles.item, styles.asset, this.props.className)}
          >
            <img
              className={styles.icon}
              src={
                _.get(this.props.item, "asset.icon.thumbnail") ||
                DefaultAssetIcon
              }
            />
            <div className={styles.discoveryTitle}>
              <Tooltip content={_.get(this.props.item, 'asset.name')} placement="bottom">
                <h5 className={styles.title}>
                  {_.get(this.props.item, "asset.name")}
                </h5>
              </Tooltip>
              <ul className={styles.metrics}>
                <li>
                  {this.localizedCommons.added}:{" "}
                  {dateFormat(
                    _.get(this.props.item, "asset.createdDate"),
                    "dd mmm yyyy"
                  )}
                </li>
                <li>
                  {this.localizedTabsCommons.author}: {formatName(_.get(this.props.item, "asset.author"))}
                </li>
              </ul>
            </div>
          </a>
        </Col>
        <Col className={styles.column} md={2}>
          0
        </Col>
        <Col className={styles.column} md={2}>
          0
        </Col>
        <Col className={styles.column} md={2}>
          00:00
        </Col>
      </Row>
    );
  }
}

export default connect(
  (state, ownProps) => {
    return {
      value: state.legacyRootReducer.reports.discovery.contentMatrix.item,
      assets: state.legacyRootReducer.reports.discovery.contentMatrixAssets,
    };
  },

  (dispatch) => {
    return {
      fetchData: (filter) => {
        return dispatch(fetchDiscoveryContentMatrix(filter));
      },

      fetchAssets: (filter, page, limit) => {
        return dispatch(fetchDiscoveryContentMatrxAssets(filter, page, limit));
      },
    };
  }
)(DiscoveryMatrixReport);
